import { render, staticRenderFns } from "./SpotDetailsView.vue?vue&type=template&id=1b546ade&lang=pug&"
import script from "./SpotDetailsView.vue?vue&type=script&lang=ts&"
export * from "./SpotDetailsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports